import { useEffect } from 'react';
import { useUIStore } from '../store/uiStore';

/**
 * Tab-bar hold for INLINE BottomSheets (mounted-while-visible, onChange
 * close detection): CommentsSheet, ClaimSheet. For BottomSheetModal
 * sheets use useSheetPresentation, which owns present/dismiss as well.
 *
 * Invariant: acquire and release exactly once per open. The cleanup is
 * registered only after hideTabBar() ran — a release without a matching
 * acquire would steal another holder's refcount (e.g. the map's structure
 * sheet) and un-hide the bar underneath it.
 */
export function useBottomSheetTabBarVisibility(isOpen: boolean): void {
  const { hideTabBar, showTabBar } = useUIStore();
  useEffect(() => {
    if (!isOpen) return;
    hideTabBar();
    return () => showTabBar();
  }, [isOpen, hideTabBar, showTabBar]);
}
